import { render, staticRenderFns } from "./DServerWHM.vue?vue&type=template&id=48ccba3b&"
import script from "./DServerWHM.vue?vue&type=script&lang=js&"
export * from "./DServerWHM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ccba3b')) {
      api.createRecord('48ccba3b', component.options)
    } else {
      api.reload('48ccba3b', component.options)
    }
    module.hot.accept("./DServerWHM.vue?vue&type=template&id=48ccba3b&", function () {
      api.rerender('48ccba3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Dedicated/DServerWHM.vue"
export default component.exports